import { Component, OnInit, Input } from '@angular/core';

import { SettingsService } from "../../services/settings/settings.service";
import { UserService } from '../../services/user/user.service';
import * as $ from "jquery";

@Component({
  selector: 'sb-site-header',
  templateUrl: './site-header.component.html',
  styleUrls: ['./site-header.component.scss'],
})
export class SiteHeaderComponent implements OnInit {

  @Input("mode-name") modeName: string;

  // String because all HTML attributes are strings, so if they come in via a web component
  // from the KO side they will be a string. It could only be a boolean if coming in from an Angular component.
  @Input("is-tenancy-enabled") isTenancyEnabled: string = "false";

  isMultilingual: boolean = false;
  canViewUserSettings: boolean = false;
  isPortalOnly: boolean = false;
  environmentName: string;
  versionName: string;
  storedHomePage$ = this.userService.userProfileSetting$("user.home.page");

  constructor(
    public settingsService: SettingsService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    // settings
    this.canViewUserSettings = this.settingsService.settings.canViewUserSettings;
    this.isMultilingual = this.userService.isMultilingual();
    this.isPortalOnly = (this.settingsService.settings["selfServiceOnly"] === true);

    // version number
    this.versionName = this.settingsService.get('build.deployedVersion', 'unknown');

    // environment name
    const envName = this.settingsService.get('instanceOverride.instance_header_text', "");

    if (envName != null && envName != "") {
      this.environmentName = envName;
    }

    // header colour override
    const headerColourOverride = this.settingsService.get('instanceOverride.header_background_color', '');
    if (headerColourOverride !== '') {
      $(`<style>.instance-header-override{ background-color:${headerColourOverride} !important;}</style>`).appendTo('head');
    }
  }

  toggleMenu() {
    document.querySelector('body')?.classList.toggle('menu-active');
    setTimeout(function() { window.dispatchEvent(new Event('resize')); }, 300);
  }

}
